import { useState } from 'react';
import { Form, TextAreaAutosize as TextArea, SubmitButton } from '@components/shared/forms';
import { useParams, Prompt } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import Button from '@components/shared/V2Button';
import api from '@shared/api';
import routes from '@root/routes';
import s from './ListingDescription.module.less';

type Props = {
  description: string;
  readOnly: boolean;
  tourbookListingId: string;
  className?: string;
};

const ListingDescription = ({
  description: rawDescription,
  readOnly,
  tourbookListingId,
  className,
}: Props) => {
  const { t } = useTranslation('tourbook');
  const { tourbookId } = useParams<{ tourbookId: string }>();
  const [isEditing, setIsEditing] = useState(false);
  const [previousDescription, setPreviousDescription] = useState(rawDescription);
  const [description, setDescription] = useState(rawDescription);
  const handleSubmit = async () => {
    await api.put(routes.api.tourbookTourbookListing({ tourbookId, tourbookListingId }), {
      description,
    });
    setPreviousDescription(description);
    setIsEditing(false);
  };
  const handleBlur = () => description === previousDescription && setIsEditing(false);
  const handleCancel = () => {
    setDescription(previousDescription);
    setIsEditing(false);
  };
  const unsavedChangesExist = () => description !== previousDescription;

  if (readOnly) {
    return <pre className={classnames(s.listingDescription, className)}>{rawDescription}</pre>;
  }

  return (
    <>
      <Prompt
        when={unsavedChangesExist()}
        message={t('listingCard.listingDescription.unsavedChangesPrompt')}
      />
      <div className={s.listingDescription}>
        <Form id={tourbookListingId} initialValues={{ description }} onSubmit={handleSubmit}>
          <TextArea
            name="description"
            className={classnames(s.textArea, isEditing && s.isEditing)}
            labelText={null}
            placeholder={t('listingCard.listingDescription.placeholder')}
            onFocus={() => setIsEditing(true)}
            onBlur={handleBlur}
            onChange={() => e => setDescription(e.target.value)}
            value={description}
          />
          <div className={classnames(s.actions, !isEditing && s.hidden)}>
            <SubmitButton size="medium" onMouseDown={e => e.preventDefault()}>
              {t('listingCard.listingDescription.save')}
            </SubmitButton>
            <Button size="medium" type="secondary" onMouseDown={handleCancel} className={s.cancel}>
              {t('listingCard.listingDescription.cancel')}
            </Button>
          </div>
        </Form>
      </div>
    </>
  );
};

export default ListingDescription;
